/**
 * iSTAT (Survey123) shared constants and URL builder.
 * Used by the Case Record iSTAT tab, Call Center, and New Client pages.
 */

export const SURVEY123_BASE = 'https://survey123.arcgis.com/share/344d59d323fd47b3bab8e8cd60b64585';

export const VSO_INCIDENTS = [
  { id: 'SSVF-TX-2026-001', label: 'SSVF – Austin Area (2026)' },
  { id: 'VHAP-TX-2026-001', label: 'Veterans Housing Assistance – South TX (2026)' },
  { id: 'SSVF-TX-2025-001', label: 'SSVF – Austin Area (2025)' },
  { id: 'VHAP-TX-2025-001', label: 'Veterans Housing Assistance – South TX (2025)' },
  { id: 'TVC-GENERAL-2026', label: 'General Benefits Assessment (2026)' },
  { id: 'TVC-CRISIS-2026', label: 'Crisis / Emergency Assistance (2026)' },
] as const;

export interface IstatPrefillData {
  incidentId: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  street?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  county?: string | undefined;
  zip?: string | undefined;
}

/** Build a full Survey123 URL with pre-filled fields. */
export function buildIstatUrl(data: IstatPrefillData): string {
  const params = new URLSearchParams();
  params.set('field:incident_id', data.incidentId);
  params.set('field:location_type', 'residence');
  params.set('field:ag_losses', 'no');
  if (data.firstName) params.set('field:first_name', data.firstName);
  if (data.lastName) params.set('field:last_name', data.lastName);
  if (data.phone) params.set('field:phone_number', data.phone);
  if (data.email) params.set('field:email_address', data.email);
  if (data.street) params.set('field:user_street', data.street);
  if (data.city) params.set('field:user_city', data.city);
  if (data.state) params.set('field:state_territory', data.state);
  if (data.county) params.set('field:county', data.county);
  if (data.zip) params.set('field:zip', data.zip);
  return `${SURVEY123_BASE}?${params.toString()}`;
}
